export default __webpack_public_path__ + "static/media/blank.986b1d3f.jpg";